import { useState } from 'react';
import { Caption, Text } from '@vkontakte/vkui';
import { Icon24CalendarOutline, Icon24ChevronDown, Icon24ChevronUp } from '@vkontakte/icons';
import { fmtDate } from './taskUtils';

type Props = {
  weddingDate?: string | null;
  stats: { done: number; total: number; overdue: number };
  shown?: number;
};

export function TaskStatsPill({ weddingDate, stats, shown }: Props) {
  const [open, setOpen] = useState(false);
  const pct = stats.total ? Math.round((stats.done / stats.total) * 100) : 0;
  return (
    <div className="tp-pill">
      <button type="button" className="tp-pill__row" aria-expanded={open} onClick={() => setOpen(!open)}>
        <span className="tp-pill__date">
          <Icon24CalendarOutline width={18} height={18} />
          {weddingDate ? `Свадьба ${fmtDate(weddingDate)}` : 'Дата свадьбы не задана'}
        </span>
        <span className="tp-pill__progress">
          {stats.done}/{stats.total} · {pct}%
        </span>
        {open ? <Icon24ChevronUp width={18} height={18} /> : <Icon24ChevronDown width={18} height={18} />}
      </button>
      <div className="tp-pill__bar">
        <div className="tp-pill__bar-fill" style={{ width: `${pct}%` }} />
      </div>
      {open && (
        <div className="tp-pill__detail">
          <Text>Выполнено: {stats.done} из {stats.total}</Text>
          <Text>Общий прогресс: {pct}%</Text>
          {stats.overdue > 0 && <Text style={{ color: 'var(--tp-status-overdue)' }}>Просрочено: {stats.overdue}</Text>}
          {shown !== undefined && shown < stats.total && (
            <Caption style={{ color: 'var(--tp-text-secondary)' }}>Показано {shown} из {stats.total}</Caption>
          )}
        </div>
      )}
    </div>
  );
}
